import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

/**
 * Action dispatched when the MChat enabled state is updated.
 * @param mailboxInfo Optional MailboxInfo for which the state is updated.
 */
export const onIsMChatEnabledUpdated: (mailboxInfo?: MailboxInfo) => {
    mailboxInfo?: MailboxInfo;
} = action('onIsMChatEnabledUpdated', (mailboxInfo?: MailboxInfo) => ({
    mailboxInfo,
}));
